export default "__VITE_ASSET__8viuibrf__"